import PropTypes from "prop-types";
import React, { useMemo, useRef } from "react";
import OderInfo from "./oder-info";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router";

import "./list.scss";
import ExternalOrderInfo from "./external-order-info";
import moment from "moment";
const ListItemOder = (props) => {
  const {
    listData = [],
    handleShowMore = () => { },
    total = 10,
    title,
    status,
    renderActionExternalItem,
    listExternalData = [],
  } = props;
  const navigate = useNavigate();
  const contentRef = useRef()

  const renderItems = useMemo(() => {
    const itemMap = new Map();
    listExternalData?.forEach(item => {
      itemMap.set(item.createdAt, [item.id, <ExternalOrderInfo
        id={item.id}
        name={item.data?.name}
        price={item.data?.total}
        createdAt={item.createdAt}
        address={item.data?.address}
        renderAction={renderActionExternalItem}
        item={item}
      />]
      )
    })
    listData?.forEach(item => {
      itemMap.set(item.createdAt, [item.id, <OderInfo
        id={item.id}
        addressFullText={item.addressDeliver?.addressFullText}
        name={item.name}
        phone={item.phone}
        price={item.total}
        createdAt={item.createdAt}
        cancelReason={item.cancelReason}
        status={item.status}
        handleDetail={() => handleDetail(item)}
      />])
    })
    return Array.from(itemMap.entries())
      .sort((a, b) => {
        console.log(a[0], b[0])
        return moment(a[0]).isBefore(moment(b[0])) ? 1 : -1
      })
      .map(([_, [id, item]]) => <div
        key={`list-item-${(id).toString()}`}
        className="list-item_item"
      >{item}</div>)
  }, [listExternalData, listData])
  const handleDetail = (item) => {
    navigate({
      pathname: `/oder-manager/${item.id}`,
      state: {
        status: 'INFO',
        idBill: item.id,
      }
    });
  };

  return (
    <div className="list-item">
      <div className="list-item_title" onClick={() => {
        contentRef.current.focus();
      }}>
        <h5>{title}</h5>
      </div>
      <div
        className="list-item_list"
        id={`scroll-infinite-${status}`}
        ref={contentRef}
        tabIndex="0">
        {(listData.length > 0 || listExternalData.length > 0) ? (
          <InfiniteScroll

            scrollableTarget={`scroll-infinite-${status}`}
            dataLength={listData.length + listExternalData.length}
            next={() => handleShowMore(status)}
            hasMore={listData.length < total}
            loader={<h4>Đang lấy dữ liệu...</h4>}
            endMessage={
              <p style={{ textAlign: "center", marginTop: "10px" }}>
                <b>Đã hết sản phẩm</b>
              </p>
            }
          >
            {renderItems}
          </InfiniteScroll>
        ) : (
          <h6 className="text-center"> Chưa có đơn hàng </h6>
        )}
      </div>
      <div className="list-item_totalOder">
        {/* <h5 >{`${total} đơn`}</h5> */}
      </div>
    </div>
  );
};

export default ListItemOder;

ListItemOder.propTypes = {
  listData: PropTypes.array,
  title: PropTypes.string,
  handleShowMore: PropTypes.func,
  totalList: PropTypes.number,
  status: PropTypes.string,
  handleConfirmed: PropTypes.func,
  handlePreparing: PropTypes.func,
  handleDelivery: PropTypes.func,
  handleFinish: PropTypes.func,
  handleCancel: PropTypes.func,
};
